import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { api } from "../lib/api";

export default function IndicacaoRef() {
  const { codigo } = useParams();
  const navigate = useNavigate();
  const [erro, setErro] = useState("");

  useEffect(() => {
    (async () => {
      try {
        await api.post(`/indicador/ref/${encodeURIComponent(codigo)}`);
        localStorage.setItem("cjr_ref", String(codigo || "").toUpperCase());
        navigate("/", { replace: true });
      } catch (e) {
        setErro(e.response?.data?.detail || "Link de indicação inválido ou inativo.");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigo]);

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-6" data-testid="indicacao-ref">
      {erro ? (
        <div className="text-center">
          <p className="text-white font-semibold" data-testid="indicacao-ref-erro">{erro}</p>
          <Link to="/" className="block mt-4 text-xs text-[#F5B301] underline" data-testid="indicacao-ref-home">Ir para o início</Link>
        </div>
      ) : (
        <div className="w-10 h-10 border-4 border-[#F5B301] border-t-transparent rounded-full animate-spin" data-testid="indicacao-ref-loading" />
      )}
    </div>
  );
}
